import Box, { BoxProps } from '@mui/material/Box'
import React, { createContext } from 'react'
import { PopoverPosition } from '../utils'
import { Void } from '@acme/common'

interface MenuRootProps extends Omit<BoxProps, 'position'> {
    position?: PopoverPosition
    arrow?: boolean
}

type EventContext = React.MouseEvent<any>

interface MenuContextProps {
    id: string
    open: boolean
    anchorEl: HTMLElement | null
    handleClose: (event: EventContext) => void
    handleClick: (event: EventContext) => void
    position: PopoverPosition
    arrow?: boolean
}

export const MenuContext = createContext<MenuContextProps>({
    id: 'MenuRoot',
    open: false,
    anchorEl: null,
    handleClose: Void,
    handleClick: Void,
    position: 'center',
    arrow: false,
})

export default function MenuRoot({
    children,
    id,
    position = 'center',
    arrow,
    ...rest
}: MenuRootProps) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <MenuContext.Provider
            value={{
                open,
                anchorEl,
                handleClose,
                handleClick,
                id: id || 'MenuRoot',
                position,
                arrow,
            }}
        >
            <Box id={id || 'MenuRoot'} {...rest}>
                {children}
            </Box>
        </MenuContext.Provider>
    )
}
